import { Component, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormGroupDirective,
  NgForm,
  Validators
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ConfigService } from 'src/app/_services/config.service';
import { SessionStorageService } from 'src/app/_services/session-storage.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: UntypedFormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  templateUrl: 'temp-password-reset.component.html',
  styleUrls: ['temp-password-reset.component.css']
})
export class TempPasswordResetComponent implements OnInit {
  isLoading = true;
  passwordResetForm: UntypedFormGroup;
  passwordsMatch = true;
  submitted = false;
  passwordErrorMessage = '';
  isDone = false;

  frmPassword = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(9)
  ]);
  frmConfirmPassword = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(9)
  ]);

  matcher = new MyErrorStateMatcher();

  constructor(
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public snackBar: MatSnackBar
  ) {
    if (this.activatedRoute.snapshot.queryParams.jwt) {
      // TODO: Use a Guard to do this!
      this.sessionStorageService.set(
        'jsonToken',
        this.activatedRoute.snapshot.queryParams.jwt
      );
      this.router.navigateByUrl(`/auth/reset-password`);
    }
    this.isLoading = false;
  }

  ngOnInit() {

  }

  onSubmitPasswordReset() {
    if (this.frmPassword.value !== this.frmConfirmPassword.value) {
      return this.snackBar.open('Passwords do not match', 'Dismiss', {
        duration: 8000
      });
    }

    this.isLoading = true;
    this.authenticationService
      .resetPassword(this.frmPassword.value)
      .toPromise()
      .then(
        data => {
          this.isLoading = false;
          this.snackBar.open(
            `You will be redirected to login in 5 seconds.
          Please login again to allow your browser to update your password`,
            'Dismiss',
            {
              duration: 7000
            }
          );
          setTimeout(() => {
            window.top.location.href = this.configService.get('mwiPortalUrl');
          }, 5000);
        },
        error => {
          this.isLoading = false;
          this.snackBar.open(error.errorMessage, 'Dismiss', {
            duration: 5000
          });
        }
      );
  }

  // UI toggles
  shouldDisableSubmitButton(): boolean {
    const bothValid = this.frmPassword.valid && this.frmConfirmPassword.valid;
    return !bothValid;
  }

  shouldShowLoader(): boolean {
    return this.isLoading;
  }
}
